const selectors = {
    newsletter: '#newsletter-modal',
    newsletterClose: '[js-newsletter-close]',
    newsletterOpen: '[js-newsletter-open]'
}

const newsletter = document.querySelector(selectors.newsletter);
const newsletterClose = document.querySelectorAll(selectors.newsletterClose);
const newsletterOpen = document.querySelectorAll(selectors.newsletterOpen);

if (newsletter) {

    newsletterClose.forEach(item => {
        item.addEventListener('click', event => {
            event.preventDefault();
            newsletter.classList.remove("modal--openned");
        })
    })

    newsletterOpen.forEach(item => {
        item.addEventListener('click', event => {
            event.preventDefault();
            newsletter.classList.add("modal--openned");
        })
    })

}
